module.exports = __webpack_public_path__ + "img/working-process.1d3fc428.jpg";